import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { showSuccessSnackbar } from "../../../components/snackBar/snakbar";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { MoneyFormatv2, MoneyFormatv3 } from "../../../library/MoneyFormat";
import DeletePayments from "./DeletePayments";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function ListLinkedInvoices({
  items,
  paymentNo,
  invNo,
  setItems,
  data,
  setInvNo,
  setPaymentNo,
  getInvoicesAndPayments
}) {
 const [objectID,setObjectID]=useState("")
 const [transID,setTransID]=useState("")
  const header = [
    {
      id: "S. No",
      label: "S. No",
      width: 20,
      align: "left",
      currency: "",
      required: "",
    },
    {
      id: "Invoice Number",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Voucher Number "
          : "Invoice Number",
      width: 30,
      align: "left",
    },
    {
      id: "Invoice Date",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Voucher Date"
          : "Invoice Date",
      width: 30,
      align: "left",
    },
    {
      id: "Invoice Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Purchase Amount (₹)"
          : "Invoice Amount (₹)",
      width: 30,
      align: "right",
      required: "",
    },
    {
      id: "Receipt Number",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Payment Number"
          : "Receipt Number",
      width: 30,
      align: "right",
    },
    {
      id: "Receipt Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Payment Amount (₹)"
          : "Receipt Amount (₹)",
      width: 30,
      align: "right",
    },
    {
      id: "Allocated to Invoice",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Allocated to Purchase (₹)"
          : "Allocated to Invoice (₹)",
      width: 30,
      align: "right",
    },

    {
      id: "Unlinked Receipt",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Unlinked  Payment (₹) "
          : "Unlinked Receipt (₹)",
      width: 30,
      align: "right",
    },
    {
      id: "Unlinked Invoice Balance",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Unlinked Purchases  (₹)"
          : "Unlinked Invoices (₹)",
      width: 30,
      align: "right",
    },
    {
      id: "UnLink",
      label: "UnLink",
      width: 20,
      align: "center",
    },
  ];
  const classes = useStyles();
  const [deleteEntriesModal, setDeleteEntriesModal] = useState(false);
  return (
    <Paper
      sx={{
        borderRadius: "8px",
        backgroundColor: "background.paper",
        marginBottom: "10px",
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        padding: { xs: "10px 0px", sm: "10px 10px" },
        borderRadius: "8px",
        transition: "all 1s ease-in-out",
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        ":hover": {
          boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
        },
        transition: "all 1s ease-in-out",
        ".MuiTableCell-root": {
          padding: "0px 5px",
        },
        ".MuiTableCell-head": {
          borderBottom: "0px",
          fontWeight: "bold",
        },
      }}
    >
      <TableContainer>
        <Table stickyHeader className={classes.table} id="EntryTable">
          <TableHead sx={{ height: "40px" }}>
            <TableRow>
              {header.map((col, ind) => {
                return (
                  <TableCell
                    key={ind}
                    align={col.align}
                    // width={col.width}
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                      color: "input.label",
                      backgroundColor: "background.tablebg",
                    }}
                  >
                    <Typography variant="h4"> {col.label}</Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length > 0 ? (
              items.map((col, index) => {
                return (
                  <TableRow key={index} height="40px">
                    <TableCell sx={{width:20}}>{index + 1}</TableCell>
                    <TableCell sx={{width:30}}>{col?.invoiceNumber}</TableCell>
                    <TableCell sx={{width:30}}>{col.date}</TableCell>
                    <TableCell sx={{width:30}} align="right">
                      {MoneyFormatv3(col?.invoiceAmount)}
                    </TableCell>
                    <TableCell sx={{width:30}}>{col?.paymentNumber}</TableCell>
                    <TableCell sx={{width:30}} align="right">
                      {MoneyFormatv3(col?.paymentAmount)}
                    </TableCell>
                    <TableCell sx={{width:30}} align="right">
                      {MoneyFormatv3(col?.linkedAmount)}
                    </TableCell>
                    <TableCell sx={{width:30}} align="right">
                      {MoneyFormatv3(col?.unlinkedPaymentAmount)}
                    </TableCell>
                    <TableCell sx={{width:30}}align="right">
                      {MoneyFormatv3(col?.invoiceBalanceAmount)}
                    </TableCell>

                    <TableCell sx={{width:20}} align="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <IconButton
                          disableRipple
                          aria-label="delete"
                          sx={{
                            margin: "0px 2px",
                            padding: "5px",
                            backgroundColor: "#fbc7c78c",
                          }}
                          onClick={() => {
                            setObjectID(col?.ObjectID)
                            setTransID(col.TransactionID)
                            setDeleteEntriesModal(true);
                          }}
                        >
                          <LinkOffIcon
                            sx={{
                              fontSize: "15px",
                              color: "#eb6a6a",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={10}>
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DeletePayments
        open={deleteEntriesModal}
        setOpen={setDeleteEntriesModal}
        showSuccessSnackbar={showSuccessSnackbar}
        ObjectID={objectID}
        data={data}
        TransactionID={transID}
        getInvoicesAndPayments={(obj) => getInvoicesAndPayments(obj)}
      />
    </Paper>
  );
}

export default ListLinkedInvoices;
